import React from "react";
import ScopeTypePill from "../molecules/ScopeTypePill";
import RolePill from "../molecules/RolePill";
import RoleTableActions from "../molecules/RoleTableActions";
import TablePaginationFooter from "../../ui/molecules/TablePaginationFooter";
import type { RoleFormData } from "./CreateRoleDrawer";

interface RolesTableProps {
  roles: RoleFormData[];
  loading?: boolean;
  error?: string | null;
  onViewRole?: (role: RoleFormData) => void;
  onEditRole?: (role: RoleFormData) => void;
  page: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

const RolesTable: React.FC<RolesTableProps> = ({
  roles,
  loading = false,
  error,
  onViewRole,
  onEditRole,
  page,
  totalPages,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
}) => {
  if (loading) {
    return (
      <div className="access-management-table-wrapper">
        <div className="text-center py-5 text-muted">Loading roles...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="access-management-table-wrapper">
        <div className="text-center py-5 text-danger">{error}</div>
      </div>
    );
  }

  return (
    <>
      <div className="access-management-table-wrapper">
        <div className="table-responsive">
          <table className="access-management-table table align-middle table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col">Role Name</th>
                <th scope="col">Scope Type</th>
                <th scope="col"># Permissions</th>
                <th scope="col">Created By</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {roles.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center py-4 text-muted">
                    No roles found
                  </td>
                </tr>
              ) : (
                roles.map((role) => (
                  <tr key={role.id}>
                    <td>
                      <RolePill role={role.name} />
                    </td>
                    <td>
                      {role.scopeType ? (
                        <ScopeTypePill type={role.scopeType} />
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                    <td>
                      <span className="roles-table-permissions-count">
                        {role.permissionsCount ?? "-"}
                      </span>
                    </td>
                    <td>
                      <span className="roles-table-created-by">
                        {role.createdBy ?? "-"}
                      </span>
                    </td>
                    <td>
                      <RoleTableActions
                        onView={onViewRole ? () => onViewRole(role) : undefined}
                        onEdit={onEditRole ? () => onEditRole(role) : undefined}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <TablePaginationFooter
        page={page}
        totalPages={Math.max(1, totalPages)}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </>
  );
};

export default RolesTable;
